import React, { useState, useEffect } from 'react';
import { Flex, Heading, Image, useColorModeValue, IconButton, useDisclosure, HStack, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Text } from '@chakra-ui/react';
import { SearchIcon, DownloadIcon } from '@chakra-ui/icons';
import ColorModeToggle from './ColorModeToggle';
import GlobalSearchModal from './common/GlobalSearchModal';

export default function TopBar() {
  const bg = useColorModeValue('white', 'brand.800');
  const textColor = useColorModeValue('brand.800', 'white');
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  // PWA Install Logic
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const { isOpen: isIOSModalOpen, onOpen: onOpenIOSModal, onClose: onCloseIOSModal } = useDisclosure();

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      setIsStandalone(true);
    }

    // Detect iOS
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(userAgent)) {
      setIsIOS(true);
    }

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const handleInstallClick = async () => {
    if (isIOS) {
      onOpenIOSModal();
    } else if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setDeferredPrompt(null);
      }
    }
  };

  const showInstallButton = !isStandalone && (deferredPrompt || isIOS);

  return (
    <>
      <Flex
        as="header"
        bg={bg}
        color={textColor}
        align="center"
        h={{ base: '60px', md: '72px' }}
        boxShadow="sm"
        px={{ base: 3, md: 4 }}
        justify="space-between"
      >
        <Flex align="center" minW={0}>
          <Image
            src="/images/generales/logo.png"
            alt="Logo de la Iglesia"
            boxSize={{ base: '40px', md: '56px' }}
            mr={{ base: 2, md: 3 }}
            borderRadius="md"
            flexShrink={0}
          />
          <Heading
            size={{ base: 'xs', md: 'md' }}
            color={textColor}
            noOfLines={1}
          >
            Sala Evangélica, Barrio Lempira
          </Heading>
        </Flex>

        <HStack spacing={2}>
          {showInstallButton && (
            <IconButton 
              icon={<DownloadIcon />} 
              variant="ghost" 
              aria-label="Instalar App" 
              onClick={handleInstallClick}
              size={{ base: "sm", md: "md" }}
            />
          )}
          <IconButton 
            icon={<SearchIcon />} 
            variant="ghost" 
            aria-label="Buscar" 
            onClick={onOpen}
            size={{ base: "sm", md: "md" }}
          />
          <ColorModeToggle />
        </HStack>
      </Flex>

      <GlobalSearchModal isOpen={isOpen} onClose={onClose} />

      {/* Modal Instrucciones iOS */}
      <Modal isOpen={isIOSModalOpen} onClose={onCloseIOSModal} isCentered>
        <ModalOverlay />
        <ModalContent mx={4}>
          <ModalHeader>Instalar en iPhone / iPad</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Text mb={3}>
              Para instalar la app en tu dispositivo iOS, sigue estos pasos:
            </Text>
            <Text mb={2}>
              1. Toca el ícono de <b>Compartir</b> en la barra inferior de Safari (el cuadrado con una flecha hacia arriba).
            </Text>
            <Text mb={2}>
              2. Desliza el menú hacia abajo y selecciona <b>Agregar a inicio</b> (Add to Home Screen).
            </Text>
            <Text>
              3. Toca <b>Agregar</b> en la esquina superior derecha.
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onCloseIOSModal}>Entendido</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
